import { createElement, createContext, useMemo, useContext } from 'react';
import { WritingMode, WritingModeContextProps } from './types';

const defaultRtlContextProps: Readonly<WritingMode> = {
  writingMode: 'horizontal-tb',
  direction: 'ltr',
  textOrientation: 'mixed',
};
const WritingModeContext = createContext<WritingMode>(defaultRtlContextProps);

export const WritingModeConsumer = WritingModeContext.Consumer;

export const WritingModeProvider = (props: WritingModeContextProps) => {
  const value = useMemo(
    () => ({
      writingMode: props.writingMode || defaultRtlContextProps.writingMode,
      direction: props.direction || defaultRtlContextProps.direction,
      textOrientation: props.textOrientation || defaultRtlContextProps.textOrientation,
    }),
    [props.writingMode, props.direction, props.textOrientation]
  );

  return <WritingModeContext.Provider value={value}>{props.children}</WritingModeContext.Provider>;
};

export const useWritingModeContext = () => {
  return useContext(WritingModeContext);
};

/**
 * @returns true if the application should render in right-to-left mode
 */
export function useIsRTL(): boolean {
  const writingMode = useContext(WritingModeContext);
  return writingMode.direction === 'rtl';
}
